
import React,{useContext, useState, useEffect} from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { SITE_TITLE, INDEX_URL } from '../../settings/common';
import { AppContext } from '../../helpers/AppContext';
import { decrypt } from '../../helpers/encryption';
import { seo } from '../../settings/seo';
import { Validation } from '../../helpers/validation';
import WAServices from '../../services/WAServices';
import { showSuccessMessage, showErrorMessage } from '../../helpers/flash-messages';
import { encrypt } from '../../helpers/encryption';
import { ChatHeadSkeleton, ChatMessageSkeleton } from '../../helpers/ChatSkeleton';
import { ChatContent, ChatTime } from '../../helpers/ChatData';


const ChatPage = () => {
	const { chat_id } = useParams();
    const [authUser, setAuthUser] = useState({});
    const [ chatData, setChatData ] = useState({});
    const [ chats, setChats ] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState("");
    const { isSidebarHidden } = useContext(AppContext);
    const { SharedAuthUser } = useContext(AppContext);
    const { setSharedAuthUser } = useContext(AppContext);
    const navigate = useNavigate();
	const [ replyFrom, setReplyFrom ] = useState("");
	const [ updateRead, setUpdateRead ] = useState(0);
    const waServices = new WAServices();

    useEffect(() => {
        const auth_user = decrypt('__bs_auth_user');
        if (Object.keys(SharedAuthUser).length > 0) {
            setAuthUser(SharedAuthUser);
        } else if (auth_user) {
            setAuthUser(auth_user);
			console.log(auth_user);
            getUserChat(auth_user.auth_token);
        } else {
            setAuthUser({});
        }
    }, [SharedAuthUser]);

    useEffect(() => {
        seo({
            title: (chatData && typeof chatData.user !== 'undefined') ? `${SITE_TITLE} || ${chatData.user.name}` : SITE_TITLE + ' || User List',
            metaDescription: '',
        });
        renderChatHistory();
    },[chatData]);

	useEffect(() => {
		 if(!updateRead) {
			try {
				const data = { chat_id };
				waServices.markRead(authUser.auth_token, data).then(response => {
					if (response?.data?.status === 'success') {

					} else {

					}

				})
				.catch(() => {
					showErrorMessage("Server or network error.");
				});

			} catch (err) {
				showErrorMessage("Server or network error.");
			}
		} 
	});

    const getUserChat = (auth_token) => {
    	let formData = {chat_id : chat_id};
    	waServices.getUserChat(auth_token, formData).then(response => {
			 console.log("FULL API RESPONSE:", response);
        console.log("CHAT DATA FROM API:", response?.data?.data);
        console.log("CHAT HISTORY:", response?.data?.data?.wa_chat_history);
            const data = response.data;
            if(data.status === 'success') {
                setChatData(data.data);
                if(Object.keys(data.data.wa_chat_history).length > 0) {
					 console.log("Setting chats:", data.data.wa_chat_history);
					     Object.entries(data.data.wa_chat_history).forEach(([i, chat])=>{
                    console.log("Incoming chat:", chat);
                    console.log("Incoming chat time:", chat.date_time);
                });
                	setChats(data.data.wa_chat_history);
                }
				setReplyFrom(data.data.user.reply_from);
            }
            setLoading(false);
        });
    };

    const handleSendMessage = () => {
        if (message.trim() === "") return; // Prevent sending empty messages

        // Here, you can add your logic to send the message (e.g., API call).
        const newChat = {
            messaged_by: 'bot',
            message: message,
            // created_at: new Date(),
			  date_time: new Date().toISOString(),
        };
        
        setChats(prevChats => ({
            ...prevChats,
            [Object.keys(prevChats).length]: newChat,
        }));
        let formData = {message : message, number : chatData.user.phone_number};
        waServices.sendMessage(authUser.auth_token,formData).then(response=>{
        	console.log(response);
        });

        setMessage(""); // Clear the input field after sending the message
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSendMessage();
        }
    };

	const handleClick = () => {
       
		const reply_from = (replyFrom === 'user') ? 'bot':'user';
		const previous_reply_from = replyFrom;
		setReplyFrom(reply_from);
        try {
	        waServices.updateUserData(authUser.auth_token,{
				reply_from: reply_from,
				id:chatData.user.id
			}).then(response => {
	        	if(typeof response !== 'undefined') {
		        	const data = response.data;
		        	if(response.status === 200 && data.status === 'success') {
						// setReplyFrom(data.reply_from);
		        	} else {
						setReplyFrom(previous_reply_from);
		        		showErrorMessage(`${data.message}`)
		        	}
		        } else {
					setReplyFrom(previous_reply_from);
		        	showErrorMessage('Server error: Something went wrong. Please try again later.');
		        }
	        });
	    } catch (error) {
	        // Check for server-side error (500)
	        if (error.response && error.response.status === 500) {
				setReplyFrom(previous_reply_from);
	            showErrorMessage('Server error: Something went wrong. Please try again later.');
	        } else {
				setReplyFrom(previous_reply_from);
	            // Handle other types of errors, such as network errors
	            showErrorMessage('An error occurred. Please check your connection and try again.');
	        }
	    }
    };

    const renderChatHead = () => {
    	return(
    		<React.Fragment>
    			{(loading && typeof chatData.user === 'undefined') ?
    				<ChatHeadSkeleton />
    				:
    				<div className="contact-profile">
						<div className="user-detail">
							<a href="javascript:void(0)" className="cx-btn-chat"><i className="ri-add-line"></i></a>
							<img src={`${process.env.PUBLIC_URL}/assets/image/user.png`} alt="user" />
							<div className="name">
								<p>{chatData.user.name} <a href={`tel:${chatData.user.phone_number}`}>{`(${chatData.user.phone_number})`}</a></p>
								<span className="online"></span>
								
							</div>
						</div>
						<div className="d-flex justify-content-center align-items-center">
							<span className="me-2">User</span>
							<a
								href="#"
								onClick={handleClick}
								className={`toggle ${(replyFrom === 'bot')  ? 'active' : ''}`}
							>
								<span className="toggle_knob"></span>
								
							</a>
							<span className="ms-2">Bot</span>
						</div>
						
					</div>
				}
    		</React.Fragment>
    	);
    }

    const renderChatMessage = () => {
    	return (
    		<React.Fragment>
    			{(loading && Object.keys(chats).length === 0) ? 
    				<ChatMessageSkeleton />
    				:
    				<React.Fragment>
    					<ul>
							{Object.entries(chats).map(([index, chat]) => {
								  console.log("Rendering message index:", index);
    console.log("Rendering message object:", chat);
    console.log("Rendering message time:", chat.date_time);
	
								return(
									<li key={index} className={(chat.messaged_by
	 === 'bot') ? 'sent' : 'replies'}>
										<img src={(chat.messaged_by
	 === 'bot') ? `${process.env.PUBLIC_URL}/assets/image/profile.png` : `${process.env.PUBLIC_URL}/assets/image/user.png`} alt="user" />
										<p><ChatContent chat={chat} /></p>
										<ChatTime chat={chat} />
									</li>
								)
							})}
						</ul>
    				</React.Fragment>
    		    }
    		</React.Fragment>
    	);
    }

    const renderChatHistory = () => {
    	return (
	        
				<div className="cx-chatapp">
					<div className="cx-card chatapp-card p-0">
						<div id="cx_chat">
							<div className="chat-sidebar-overlay"></div>
							
							<div className="content">
								{ renderChatHead() }
								<div className="messages">
									{ renderChatMessage() }
								</div>
								<div className="message-input">
									<div className="wrap-send">
										<div className="dropdown dropdown-emoji">
											<button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
												<i className="ri-emoji-sticker-line"></i>
											</button>
											<ul className="dropdown-menu">
												<li><a className="dropdown-item" href="#">😀</a></li>
												<li><a className="dropdown-item" href="#">😁</a></li>
												<li><a className="dropdown-item" href="#">😂</a></li>
												<li><a className="dropdown-item" href="#">😃</a></li>
												<li><a className="dropdown-item" href="#">😄</a></li>
												<li><a className="dropdown-item" href="#">😅</a></li>
												<li><a className="dropdown-item" href="#">😇</a></li>
												<li><a className="dropdown-item" href="#">😆</a></li>
											</ul>
										</div>
										<div className="dropdown p-btn dropdown-pin">
											<button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
												<i className="ri-attachment-line"></i>
											</button>
											<ul className="dropdown-menu">
												<li><a className="dropdown-item" href="#"><i className="ri-user-add-line"></i><span>Contact</span></a></li>
												<li><a className="dropdown-item" href="#"><i className="ri-file-add-line"></i><span>Document</span></a></li>
												<li><a className="dropdown-item" href="#"><i className="ri-camera-3-line"></i><span>Camera</span></a></li>
												<li><a className="dropdown-item" href="#"><i className="ri-image-line"></i><span>Image</span></a></li>
											</ul>
										</div>
										<input id="sentmsg" type="text" placeholder="Write your message..." value={message}
										onChange={(e) => setMessage(e.target.value)}
										onKeyDown={handleKeyDown}/>
										<button className="submit send-btn" onClick={handleSendMessage}><i className="ri-send-plane-line"></i></button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			
	    );
    }

    

    return (
        <React.Fragment>
        	<div className={`cx-main-content ${isSidebarHidden ?'sb-hide':'' }`}>
            	{renderChatHistory()}
            </div>
        </React.Fragment>
    );
};
                            
export default ChatPage;